/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Clovie API
 * Salon management API
 * OpenAPI spec version: 0.0.1
 */
import { useInfiniteQuery, useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type {
  CheckInModeNotAvailableError,
  CreateKioskDevice,
  DeleteOrganizationKioskDevicesId200,
  GetOrganizationA2pSiteAddress200,
  GetOrganizationA2pSiteAddressAvailability200,
  GetOrganizationA2pSiteAddressAvailabilityParams,
  GetOrganizationBillingSubscription200,
  GetOrganizationBillingUsage200,
  GetOrganizationCalendarSettings200,
  GetOrganizationCancellationSettings200,
  GetOrganizationCheckInSettings200,
  GetOrganizationCheckInSettingsPosterLinks200,
  GetOrganizationCheckInSettingsPosterPdf409,
  GetOrganizationCheckInSettingsPosterPdfParams,
  GetOrganizationGiftCardArtwork200,
  GetOrganizationKioskDevices200,
  GetOrganizationMarketingAccess200,
  GetOrganizationSettings200,
  GetOrganizationSetupChangeContext200,
  GetOrganizationSetupGuide200,
  GetOrganizationSubdomain200,
  GetOrganizationSubdomainAvailability200,
  GetOrganizationSubdomainAvailabilityParams,
  PatchOrganizationA2pSiteAddress200,
  PatchOrganizationA2pSiteAddressBody,
  PatchOrganizationAdvanced200,
  PatchOrganizationAdvancedBody,
  PatchOrganizationBranding200,
  PatchOrganizationBrandingBody,
  PatchOrganizationCalendarDisplaySettings200,
  PatchOrganizationCalendarDisplaySettingsBody,
  PatchOrganizationCancellationSettings200,
  PatchOrganizationCancellationSettingsBody,
  PatchOrganizationCheckInMode200,
  PatchOrganizationCheckInModeBody,
  PatchOrganizationCheckInSettings200,
  PatchOrganizationCheckInSettings409,
  PatchOrganizationDetails200,
  PatchOrganizationDetailsBody,
  PatchOrganizationGiftCardArtwork200,
  PatchOrganizationGiftCardArtworkBody,
  PatchOrganizationPointOfSaleMode200,
  PatchOrganizationPointOfSaleModeBody,
  PatchOrganizationSetup200,
  PatchOrganizationSubdomain200,
  PatchOrganizationSubdomainBody,
  PostOrganizationBillingChangePlan200,
  PostOrganizationBillingChangePlanBody,
  PostOrganizationBillingChangePlanPreview200,
  PostOrganizationBillingChangePlanPreviewBody,
  PostOrganizationBillingCheckout200,
  PostOrganizationBillingCheckoutBody,
  PostOrganizationBillingPortal200,
  PostOrganizationBillingRefresh200,
  PostOrganizationBillingRefreshBody,
  PostOrganizationCheckInSettingsRotatePoster200,
  PostOrganizationKioskDevices201,
  PostOrganizationKioskDevices409,
  PutOrganizationBillingSpendingCap200,
  PutOrganizationBillingSpendingCapBody,
  PutOrganizationCheckInSettingsExitPin200,
  PutOrganizationSetupGuide200,
  PutOrganizationSetupGuideBody,
  SalonAddOnsChange,
  SalonSetupRefusalError,
  SetCheckInExitPin,
  UpdateCheckInSettings,
} from '.././schemas';

import { customInstance } from '../../axios-instance';

/**
 * Fetch all organization settings (business details, branding, advanced). Creates defaults if none exist.
 * @summary Get organization settings
 */
export const getOrganizationSettings = (signal?: AbortSignal) => {
  return customInstance<GetOrganizationSettings200>({
    url: `/organization/settings`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationSettingsInfiniteQueryKey = () => {
  return ['infinite', `/organization/settings`] as const;
};

export const getGetOrganizationSettingsQueryKey = () => {
  return [`/organization/settings`] as const;
};

export const getGetOrganizationSettingsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSettings>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationSettingsInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationSettings>>> = ({
    signal,
  }) => getOrganizationSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationSettingsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationSettings>>
>;
export type GetOrganizationSettingsInfiniteQueryError = unknown;

export function useGetOrganizationSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSettings>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSettings>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSettings>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get organization settings
 */

export function useGetOrganizationSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSettings>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationSettingsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationSettings>>> = ({
    signal,
  }) => getOrganizationSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationSettings>>
>;
export type GetOrganizationSettingsQueryError = unknown;

export function useGetOrganizationSettings<
  TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSettings<
  TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSettings<
  TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get organization settings
 */

export function useGetOrganizationSettings<
  TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationSettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationSettingsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationSettings>>> = ({
    signal,
  }) => getOrganizationSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationSettingsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationSettings>>
>;
export type GetOrganizationSettingsSuspenseQueryError = unknown;

export function useGetOrganizationSettingsSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSettingsSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSettingsSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get organization settings
 */

export function useGetOrganizationSettingsSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationSettingsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Read cancellation timing, waiting-client notification availability, and calendar display preferences without private configuration.
 * @summary Get operational Calendar settings
 */
export const getOrganizationCalendarSettings = (signal?: AbortSignal) => {
  return customInstance<GetOrganizationCalendarSettings200>({
    url: `/organization/calendar-settings`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationCalendarSettingsInfiniteQueryKey = () => {
  return ['infinite', `/organization/calendar-settings`] as const;
};

export const getGetOrganizationCalendarSettingsQueryKey = () => {
  return [`/organization/calendar-settings`] as const;
};

export const getGetOrganizationCalendarSettingsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCalendarSettings>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationCalendarSettingsInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationCalendarSettings>>> = ({
    signal,
  }) => getOrganizationCalendarSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationCalendarSettingsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationCalendarSettings>>
>;
export type GetOrganizationCalendarSettingsInfiniteQueryError = unknown;

export function useGetOrganizationCalendarSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCalendarSettings>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCalendarSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCalendarSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCalendarSettings>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCalendarSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCalendarSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCalendarSettings>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get operational Calendar settings
 */

export function useGetOrganizationCalendarSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCalendarSettings>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationCalendarSettingsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationCalendarSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizationCalendarSettings>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationCalendarSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationCalendarSettings>>> = ({
    signal,
  }) => getOrganizationCalendarSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationCalendarSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationCalendarSettings>>
>;
export type GetOrganizationCalendarSettingsQueryError = unknown;

export function useGetOrganizationCalendarSettings<
  TData = Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationCalendarSettings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCalendarSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCalendarSettings<
  TData = Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationCalendarSettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCalendarSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCalendarSettings<
  TData = Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationCalendarSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get operational Calendar settings
 */

export function useGetOrganizationCalendarSettings<
  TData = Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationCalendarSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationCalendarSettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationCalendarSettingsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationCalendarSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationCalendarSettings>>> = ({
    signal,
  }) => getOrganizationCalendarSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationCalendarSettingsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationCalendarSettings>>
>;
export type GetOrganizationCalendarSettingsSuspenseQueryError = unknown;

export function useGetOrganizationCalendarSettingsSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCalendarSettingsSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCalendarSettingsSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get operational Calendar settings
 */

export function useGetOrganizationCalendarSettingsSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCalendarSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationCalendarSettingsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Partial update of calendar visible-hours mode (fit opening hours or fixed), extra time, fixed visible hours (30-min steps, at least 4 hours) and zoom level.
 * @summary Update calendar display preferences
 */
export const patchOrganizationCalendarDisplaySettings = (
  patchOrganizationCalendarDisplaySettingsBody: PatchOrganizationCalendarDisplaySettingsBody
) => {
  return customInstance<PatchOrganizationCalendarDisplaySettings200>({
    url: `/organization/calendar-display-settings`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchOrganizationCalendarDisplaySettingsBody,
  });
};

export const getPatchOrganizationCalendarDisplaySettingsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOrganizationCalendarDisplaySettings>>,
    TError,
    { data: PatchOrganizationCalendarDisplaySettingsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchOrganizationCalendarDisplaySettings>>,
  TError,
  { data: PatchOrganizationCalendarDisplaySettingsBody },
  TContext
> => {
  const mutationKey = ['patchOrganizationCalendarDisplaySettings'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchOrganizationCalendarDisplaySettings>>,
    { data: PatchOrganizationCalendarDisplaySettingsBody }
  > = (props) => {
    const { data } = props ?? {};

    return patchOrganizationCalendarDisplaySettings(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchOrganizationCalendarDisplaySettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchOrganizationCalendarDisplaySettings>>
>;
export type PatchOrganizationCalendarDisplaySettingsMutationBody =
  PatchOrganizationCalendarDisplaySettingsBody;
export type PatchOrganizationCalendarDisplaySettingsMutationError = unknown;

/**
 * @summary Update calendar display preferences
 */
export const usePatchOrganizationCalendarDisplaySettings = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchOrganizationCalendarDisplaySettings>>,
      TError,
      { data: PatchOrganizationCalendarDisplaySettingsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchOrganizationCalendarDisplaySettings>>,
  TError,
  { data: PatchOrganizationCalendarDisplaySettingsBody },
  TContext
> => {
  const mutationOptions = getPatchOrganizationCalendarDisplaySettingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update business name, website URL, country code, and currency code
 * @summary Update business details
 */
export const patchOrganizationDetails = (
  patchOrganizationDetailsBody: PatchOrganizationDetailsBody
) => {
  return customInstance<PatchOrganizationDetails200>({
    url: `/organization/details`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchOrganizationDetailsBody,
  });
};

export const getPatchOrganizationDetailsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOrganizationDetails>>,
    TError,
    { data: PatchOrganizationDetailsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchOrganizationDetails>>,
  TError,
  { data: PatchOrganizationDetailsBody },
  TContext
> => {
  const mutationKey = ['patchOrganizationDetails'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchOrganizationDetails>>,
    { data: PatchOrganizationDetailsBody }
  > = (props) => {
    const { data } = props ?? {};

    return patchOrganizationDetails(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchOrganizationDetailsMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchOrganizationDetails>>
>;
export type PatchOrganizationDetailsMutationBody = PatchOrganizationDetailsBody;
export type PatchOrganizationDetailsMutationError = unknown;

/**
 * @summary Update business details
 */
export const usePatchOrganizationDetails = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchOrganizationDetails>>,
      TError,
      { data: PatchOrganizationDetailsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchOrganizationDetails>>,
  TError,
  { data: PatchOrganizationDetailsBody },
  TContext
> => {
  const mutationOptions = getPatchOrganizationDetailsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update brand color, logo URL/path, and cover image URL/path
 * @summary Update branding settings
 */
export const patchOrganizationBranding = (
  patchOrganizationBrandingBody: PatchOrganizationBrandingBody
) => {
  return customInstance<PatchOrganizationBranding200>({
    url: `/organization/branding`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchOrganizationBrandingBody,
  });
};

export const getPatchOrganizationBrandingMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOrganizationBranding>>,
    TError,
    { data: PatchOrganizationBrandingBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchOrganizationBranding>>,
  TError,
  { data: PatchOrganizationBrandingBody },
  TContext
> => {
  const mutationKey = ['patchOrganizationBranding'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchOrganizationBranding>>,
    { data: PatchOrganizationBrandingBody }
  > = (props) => {
    const { data } = props ?? {};

    return patchOrganizationBranding(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchOrganizationBrandingMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchOrganizationBranding>>
>;
export type PatchOrganizationBrandingMutationBody = PatchOrganizationBrandingBody;
export type PatchOrganizationBrandingMutationError = unknown;

/**
 * @summary Update branding settings
 */
export const usePatchOrganizationBranding = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchOrganizationBranding>>,
      TError,
      { data: PatchOrganizationBrandingBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchOrganizationBranding>>,
  TError,
  { data: PatchOrganizationBrandingBody },
  TContext
> => {
  const mutationOptions = getPatchOrganizationBrandingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update client ownership, schedule overlap, account balances, and custom email. Note: Changing email resets verification.
 * @summary Update advanced settings
 */
export const patchOrganizationAdvanced = (
  patchOrganizationAdvancedBody: PatchOrganizationAdvancedBody
) => {
  return customInstance<PatchOrganizationAdvanced200>({
    url: `/organization/advanced`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchOrganizationAdvancedBody,
  });
};

export const getPatchOrganizationAdvancedMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOrganizationAdvanced>>,
    TError,
    { data: PatchOrganizationAdvancedBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchOrganizationAdvanced>>,
  TError,
  { data: PatchOrganizationAdvancedBody },
  TContext
> => {
  const mutationKey = ['patchOrganizationAdvanced'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchOrganizationAdvanced>>,
    { data: PatchOrganizationAdvancedBody }
  > = (props) => {
    const { data } = props ?? {};

    return patchOrganizationAdvanced(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchOrganizationAdvancedMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchOrganizationAdvanced>>
>;
export type PatchOrganizationAdvancedMutationBody = PatchOrganizationAdvancedBody;
export type PatchOrganizationAdvancedMutationError = unknown;

/**
 * @summary Update advanced settings
 */
export const usePatchOrganizationAdvanced = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchOrganizationAdvanced>>,
      TError,
      { data: PatchOrganizationAdvancedBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchOrganizationAdvanced>>,
  TError,
  { data: PatchOrganizationAdvancedBody },
  TContext
> => {
  const mutationOptions = getPatchOrganizationAdvancedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Fetch cancellation policy text, self-service windows, late threshold, and visibility. Creates defaults if none exist.
 * @summary Get cancellation & reschedule settings
 */
export const getOrganizationCancellationSettings = (signal?: AbortSignal) => {
  return customInstance<GetOrganizationCancellationSettings200>({
    url: `/organization/cancellation-settings`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationCancellationSettingsInfiniteQueryKey = () => {
  return ['infinite', `/organization/cancellation-settings`] as const;
};

export const getGetOrganizationCancellationSettingsQueryKey = () => {
  return [`/organization/cancellation-settings`] as const;
};

export const getGetOrganizationCancellationSettingsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCancellationSettings>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationCancellationSettingsInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationCancellationSettings>>> = ({
    signal,
  }) => getOrganizationCancellationSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationCancellationSettingsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationCancellationSettings>>
>;
export type GetOrganizationCancellationSettingsInfiniteQueryError = unknown;

export function useGetOrganizationCancellationSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCancellationSettings>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCancellationSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCancellationSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCancellationSettings>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCancellationSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCancellationSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCancellationSettings>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get cancellation & reschedule settings
 */

export function useGetOrganizationCancellationSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCancellationSettings>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationCancellationSettingsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationCancellationSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizationCancellationSettings>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationCancellationSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationCancellationSettings>>> = ({
    signal,
  }) => getOrganizationCancellationSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationCancellationSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationCancellationSettings>>
>;
export type GetOrganizationCancellationSettingsQueryError = unknown;

export function useGetOrganizationCancellationSettings<
  TData = Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCancellationSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCancellationSettings<
  TData = Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCancellationSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCancellationSettings<
  TData = Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get cancellation & reschedule settings
 */

export function useGetOrganizationCancellationSettings<
  TData = Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationCancellationSettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationCancellationSettingsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationCancellationSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationCancellationSettings>>> = ({
    signal,
  }) => getOrganizationCancellationSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationCancellationSettingsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationCancellationSettings>>
>;
export type GetOrganizationCancellationSettingsSuspenseQueryError = unknown;

export function useGetOrganizationCancellationSettingsSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCancellationSettingsSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCancellationSettingsSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get cancellation & reschedule settings
 */

export function useGetOrganizationCancellationSettingsSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCancellationSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationCancellationSettingsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Partial update of policy text, self-service windows, late threshold, and calendar visibility.
 * @summary Update cancellation & reschedule settings
 */
export const patchOrganizationCancellationSettings = (
  patchOrganizationCancellationSettingsBody: PatchOrganizationCancellationSettingsBody
) => {
  return customInstance<PatchOrganizationCancellationSettings200>({
    url: `/organization/cancellation-settings`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchOrganizationCancellationSettingsBody,
  });
};

export const getPatchOrganizationCancellationSettingsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOrganizationCancellationSettings>>,
    TError,
    { data: PatchOrganizationCancellationSettingsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchOrganizationCancellationSettings>>,
  TError,
  { data: PatchOrganizationCancellationSettingsBody },
  TContext
> => {
  const mutationKey = ['patchOrganizationCancellationSettings'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchOrganizationCancellationSettings>>,
    { data: PatchOrganizationCancellationSettingsBody }
  > = (props) => {
    const { data } = props ?? {};

    return patchOrganizationCancellationSettings(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchOrganizationCancellationSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchOrganizationCancellationSettings>>
>;
export type PatchOrganizationCancellationSettingsMutationBody =
  PatchOrganizationCancellationSettingsBody;
export type PatchOrganizationCancellationSettingsMutationError = unknown;

/**
 * @summary Update cancellation & reschedule settings
 */
export const usePatchOrganizationCancellationSettings = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchOrganizationCancellationSettings>>,
      TError,
      { data: PatchOrganizationCancellationSettingsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchOrganizationCancellationSettings>>,
  TError,
  { data: PatchOrganizationCancellationSettingsBody },
  TContext
> => {
  const mutationOptions = getPatchOrganizationCancellationSettingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Fetch default artwork library and organization gift card artwork selection.
 * @summary Get gift card artwork settings
 */
export const getOrganizationGiftCardArtwork = (signal?: AbortSignal) => {
  return customInstance<GetOrganizationGiftCardArtwork200>({
    url: `/organization/gift-card-artwork`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationGiftCardArtworkInfiniteQueryKey = () => {
  return ['infinite', `/organization/gift-card-artwork`] as const;
};

export const getGetOrganizationGiftCardArtworkQueryKey = () => {
  return [`/organization/gift-card-artwork`] as const;
};

export const getGetOrganizationGiftCardArtworkInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationGiftCardArtworkInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>> = ({
    signal,
  }) => getOrganizationGiftCardArtwork(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationGiftCardArtworkInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>
>;
export type GetOrganizationGiftCardArtworkInfiniteQueryError = unknown;

export function useGetOrganizationGiftCardArtworkInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationGiftCardArtworkInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationGiftCardArtworkInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get gift card artwork settings
 */

export function useGetOrganizationGiftCardArtworkInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationGiftCardArtworkInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationGiftCardArtworkQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationGiftCardArtworkQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>> = ({
    signal,
  }) => getOrganizationGiftCardArtwork(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationGiftCardArtworkQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>
>;
export type GetOrganizationGiftCardArtworkQueryError = unknown;

export function useGetOrganizationGiftCardArtwork<
  TData = Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationGiftCardArtwork<
  TData = Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationGiftCardArtwork<
  TData = Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get gift card artwork settings
 */

export function useGetOrganizationGiftCardArtwork<
  TData = Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationGiftCardArtworkQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationGiftCardArtworkSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationGiftCardArtworkQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>> = ({
    signal,
  }) => getOrganizationGiftCardArtwork(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationGiftCardArtworkSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>
>;
export type GetOrganizationGiftCardArtworkSuspenseQueryError = unknown;

export function useGetOrganizationGiftCardArtworkSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationGiftCardArtworkSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationGiftCardArtworkSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get gift card artwork settings
 */

export function useGetOrganizationGiftCardArtworkSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationGiftCardArtwork>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationGiftCardArtworkSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Select a bundled gift card artwork image or the saved custom artwork slot.
 * @summary Update gift card artwork settings
 */
export const patchOrganizationGiftCardArtwork = (
  patchOrganizationGiftCardArtworkBody: PatchOrganizationGiftCardArtworkBody
) => {
  return customInstance<PatchOrganizationGiftCardArtwork200>({
    url: `/organization/gift-card-artwork`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchOrganizationGiftCardArtworkBody,
  });
};

export const getPatchOrganizationGiftCardArtworkMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOrganizationGiftCardArtwork>>,
    TError,
    { data: PatchOrganizationGiftCardArtworkBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchOrganizationGiftCardArtwork>>,
  TError,
  { data: PatchOrganizationGiftCardArtworkBody },
  TContext
> => {
  const mutationKey = ['patchOrganizationGiftCardArtwork'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchOrganizationGiftCardArtwork>>,
    { data: PatchOrganizationGiftCardArtworkBody }
  > = (props) => {
    const { data } = props ?? {};

    return patchOrganizationGiftCardArtwork(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchOrganizationGiftCardArtworkMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchOrganizationGiftCardArtwork>>
>;
export type PatchOrganizationGiftCardArtworkMutationBody = PatchOrganizationGiftCardArtworkBody;
export type PatchOrganizationGiftCardArtworkMutationError = unknown;

/**
 * @summary Update gift card artwork settings
 */
export const usePatchOrganizationGiftCardArtwork = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchOrganizationGiftCardArtwork>>,
      TError,
      { data: PatchOrganizationGiftCardArtworkBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchOrganizationGiftCardArtwork>>,
  TError,
  { data: PatchOrganizationGiftCardArtworkBody },
  TContext
> => {
  const mutationOptions = getPatchOrganizationGiftCardArtworkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * List active agency marketing users who can access the current organization.
 * @summary Get organization marketing access
 */
export const getOrganizationMarketingAccess = (signal?: AbortSignal) => {
  return customInstance<GetOrganizationMarketingAccess200>({
    url: `/organization/marketing-access`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationMarketingAccessInfiniteQueryKey = () => {
  return ['infinite', `/organization/marketing-access`] as const;
};

export const getGetOrganizationMarketingAccessQueryKey = () => {
  return [`/organization/marketing-access`] as const;
};

export const getGetOrganizationMarketingAccessInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationMarketingAccess>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationMarketingAccessInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationMarketingAccess>>> = ({
    signal,
  }) => getOrganizationMarketingAccess(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationMarketingAccessInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationMarketingAccess>>
>;
export type GetOrganizationMarketingAccessInfiniteQueryError = void;

export function useGetOrganizationMarketingAccessInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationMarketingAccess>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationMarketingAccess>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationMarketingAccessInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationMarketingAccess>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationMarketingAccess>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationMarketingAccessInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationMarketingAccess>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get organization marketing access
 */

export function useGetOrganizationMarketingAccessInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationMarketingAccess>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationMarketingAccessInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationMarketingAccessQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizationMarketingAccess>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationMarketingAccessQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationMarketingAccess>>> = ({
    signal,
  }) => getOrganizationMarketingAccess(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationMarketingAccessQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationMarketingAccess>>
>;
export type GetOrganizationMarketingAccessQueryError = void;

export function useGetOrganizationMarketingAccess<
  TData = Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationMarketingAccess>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationMarketingAccess>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationMarketingAccess<
  TData = Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationMarketingAccess>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationMarketingAccess>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationMarketingAccess<
  TData = Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationMarketingAccess>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get organization marketing access
 */

export function useGetOrganizationMarketingAccess<
  TData = Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationMarketingAccess>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationMarketingAccessQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationMarketingAccessSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationMarketingAccessQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationMarketingAccess>>> = ({
    signal,
  }) => getOrganizationMarketingAccess(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationMarketingAccessSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationMarketingAccess>>
>;
export type GetOrganizationMarketingAccessSuspenseQueryError = void;

export function useGetOrganizationMarketingAccessSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationMarketingAccessSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationMarketingAccessSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get organization marketing access
 */

export function useGetOrganizationMarketingAccessSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationMarketingAccess>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationMarketingAccessSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get the salon web address used for marketing landing pages
 */
export const getOrganizationSubdomain = (signal?: AbortSignal) => {
  return customInstance<GetOrganizationSubdomain200>({
    url: `/organization/subdomain`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationSubdomainInfiniteQueryKey = () => {
  return ['infinite', `/organization/subdomain`] as const;
};

export const getGetOrganizationSubdomainQueryKey = () => {
  return [`/organization/subdomain`] as const;
};

export const getGetOrganizationSubdomainInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSubdomain>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationSubdomain>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationSubdomainInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationSubdomain>>> = ({
    signal,
  }) => getOrganizationSubdomain(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSubdomain>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationSubdomainInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationSubdomain>>
>;
export type GetOrganizationSubdomainInfiniteQueryError = unknown;

export function useGetOrganizationSubdomainInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSubdomain>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationSubdomain>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSubdomain>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSubdomain>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSubdomainInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSubdomain>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationSubdomain>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSubdomain>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSubdomain>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSubdomainInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSubdomain>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationSubdomain>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the salon web address used for marketing landing pages
 */

export function useGetOrganizationSubdomainInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSubdomain>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationSubdomain>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationSubdomainInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationSubdomainQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationSubdomain>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSubdomain>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationSubdomainQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationSubdomain>>> = ({
    signal,
  }) => getOrganizationSubdomain(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSubdomain>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationSubdomainQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationSubdomain>>
>;
export type GetOrganizationSubdomainQueryError = unknown;

export function useGetOrganizationSubdomain<
  TData = Awaited<ReturnType<typeof getOrganizationSubdomain>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSubdomain>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSubdomain>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSubdomain>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSubdomain<
  TData = Awaited<ReturnType<typeof getOrganizationSubdomain>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSubdomain>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSubdomain>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSubdomain>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSubdomain<
  TData = Awaited<ReturnType<typeof getOrganizationSubdomain>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSubdomain>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the salon web address used for marketing landing pages
 */

export function useGetOrganizationSubdomain<
  TData = Awaited<ReturnType<typeof getOrganizationSubdomain>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSubdomain>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationSubdomainQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationSubdomainSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationSubdomain>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationSubdomain>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationSubdomainQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationSubdomain>>> = ({
    signal,
  }) => getOrganizationSubdomain(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSubdomain>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationSubdomainSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationSubdomain>>
>;
export type GetOrganizationSubdomainSuspenseQueryError = unknown;

export function useGetOrganizationSubdomainSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSubdomain>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationSubdomain>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSubdomainSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSubdomain>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationSubdomain>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSubdomainSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSubdomain>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationSubdomain>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the salon web address used for marketing landing pages
 */

export function useGetOrganizationSubdomainSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSubdomain>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationSubdomain>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationSubdomainSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Change the salon web address label and/or domain (admin-equivalent; once public, a label change keeps a redirect and counts; a domain switch is free)
 */
export const patchOrganizationSubdomain = (
  patchOrganizationSubdomainBody: PatchOrganizationSubdomainBody
) => {
  return customInstance<PatchOrganizationSubdomain200>({
    url: `/organization/subdomain`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchOrganizationSubdomainBody,
  });
};

export const getPatchOrganizationSubdomainMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOrganizationSubdomain>>,
    TError,
    { data: PatchOrganizationSubdomainBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchOrganizationSubdomain>>,
  TError,
  { data: PatchOrganizationSubdomainBody },
  TContext
> => {
  const mutationKey = ['patchOrganizationSubdomain'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchOrganizationSubdomain>>,
    { data: PatchOrganizationSubdomainBody }
  > = (props) => {
    const { data } = props ?? {};

    return patchOrganizationSubdomain(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchOrganizationSubdomainMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchOrganizationSubdomain>>
>;
export type PatchOrganizationSubdomainMutationBody = PatchOrganizationSubdomainBody;
export type PatchOrganizationSubdomainMutationError = void;

/**
 * @summary Change the salon web address label and/or domain (admin-equivalent; once public, a label change keeps a redirect and counts; a domain switch is free)
 */
export const usePatchOrganizationSubdomain = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchOrganizationSubdomain>>,
      TError,
      { data: PatchOrganizationSubdomainBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchOrganizationSubdomain>>,
  TError,
  { data: PatchOrganizationSubdomainBody },
  TContext
> => {
  const mutationOptions = getPatchOrganizationSubdomainMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Check whether a web address label is valid and free on `domain` (default: the salon's current domain); on a shared domain (hayven.me) also checks other websites via DNS
 */
export const getOrganizationSubdomainAvailability = (
  params: GetOrganizationSubdomainAvailabilityParams,
  signal?: AbortSignal
) => {
  return customInstance<GetOrganizationSubdomainAvailability200>({
    url: `/organization/subdomain/availability`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetOrganizationSubdomainAvailabilityInfiniteQueryKey = (
  params?: GetOrganizationSubdomainAvailabilityParams
) => {
  return ['infinite', `/organization/subdomain/availability`, ...(params ? [params] : [])] as const;
};

export const getGetOrganizationSubdomainAvailabilityQueryKey = (
  params?: GetOrganizationSubdomainAvailabilityParams
) => {
  return [`/organization/subdomain/availability`, ...(params ? [params] : [])] as const;
};

export const getGetOrganizationSubdomainAvailabilityInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>>,
  TError = unknown,
>(
  params: GetOrganizationSubdomainAvailabilityParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationSubdomainAvailabilityInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>
  > = ({ signal }) => getOrganizationSubdomainAvailability(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationSubdomainAvailabilityInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>
>;
export type GetOrganizationSubdomainAvailabilityInfiniteQueryError = unknown;

export function useGetOrganizationSubdomainAvailabilityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>>,
  TError = unknown,
>(
  params: GetOrganizationSubdomainAvailabilityParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSubdomainAvailabilityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>>,
  TError = unknown,
>(
  params: GetOrganizationSubdomainAvailabilityParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSubdomainAvailabilityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>>,
  TError = unknown,
>(
  params: GetOrganizationSubdomainAvailabilityParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Check whether a web address label is valid and free on `domain` (default: the salon's current domain); on a shared domain (hayven.me) also checks other websites via DNS
 */

export function useGetOrganizationSubdomainAvailabilityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>>,
  TError = unknown,
>(
  params: GetOrganizationSubdomainAvailabilityParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationSubdomainAvailabilityInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationSubdomainAvailabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationSubdomainAvailabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationSubdomainAvailabilityQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>
  > = ({ signal }) => getOrganizationSubdomainAvailability(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationSubdomainAvailabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>
>;
export type GetOrganizationSubdomainAvailabilityQueryError = unknown;

export function useGetOrganizationSubdomainAvailability<
  TData = Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationSubdomainAvailabilityParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSubdomainAvailability<
  TData = Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationSubdomainAvailabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSubdomainAvailability<
  TData = Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationSubdomainAvailabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Check whether a web address label is valid and free on `domain` (default: the salon's current domain); on a shared domain (hayven.me) also checks other websites via DNS
 */

export function useGetOrganizationSubdomainAvailability<
  TData = Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationSubdomainAvailabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationSubdomainAvailabilityQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationSubdomainAvailabilitySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationSubdomainAvailabilityParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationSubdomainAvailabilityQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>
  > = ({ signal }) => getOrganizationSubdomainAvailability(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationSubdomainAvailabilitySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>
>;
export type GetOrganizationSubdomainAvailabilitySuspenseQueryError = unknown;

export function useGetOrganizationSubdomainAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationSubdomainAvailabilityParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSubdomainAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationSubdomainAvailabilityParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSubdomainAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationSubdomainAvailabilityParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Check whether a web address label is valid and free on `domain` (default: the salon's current domain); on a shared domain (hayven.me) also checks other websites via DNS
 */

export function useGetOrganizationSubdomainAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationSubdomainAvailabilityParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSubdomainAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationSubdomainAvailabilitySuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get the texting-compliance website address ({label}.{apex of the site type})
 */
export const getOrganizationA2pSiteAddress = (signal?: AbortSignal) => {
  return customInstance<GetOrganizationA2pSiteAddress200>({
    url: `/organization/a2p-site-address`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationA2pSiteAddressInfiniteQueryKey = () => {
  return ['infinite', `/organization/a2p-site-address`] as const;
};

export const getGetOrganizationA2pSiteAddressQueryKey = () => {
  return [`/organization/a2p-site-address`] as const;
};

export const getGetOrganizationA2pSiteAddressInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationA2pSiteAddressInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>> = ({
    signal,
  }) => getOrganizationA2pSiteAddress(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationA2pSiteAddressInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>
>;
export type GetOrganizationA2pSiteAddressInfiniteQueryError = unknown;

export function useGetOrganizationA2pSiteAddressInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationA2pSiteAddressInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationA2pSiteAddressInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the texting-compliance website address ({label}.{apex of the site type})
 */

export function useGetOrganizationA2pSiteAddressInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationA2pSiteAddressInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationA2pSiteAddressQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationA2pSiteAddressQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>> = ({
    signal,
  }) => getOrganizationA2pSiteAddress(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationA2pSiteAddressQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>
>;
export type GetOrganizationA2pSiteAddressQueryError = unknown;

export function useGetOrganizationA2pSiteAddress<
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationA2pSiteAddress<
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationA2pSiteAddress<
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the texting-compliance website address ({label}.{apex of the site type})
 */

export function useGetOrganizationA2pSiteAddress<
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationA2pSiteAddressQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationA2pSiteAddressSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationA2pSiteAddressQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>> = ({
    signal,
  }) => getOrganizationA2pSiteAddress(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationA2pSiteAddressSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>
>;
export type GetOrganizationA2pSiteAddressSuspenseQueryError = unknown;

export function useGetOrganizationA2pSiteAddressSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationA2pSiteAddressSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationA2pSiteAddressSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the texting-compliance website address ({label}.{apex of the site type})
 */

export function useGetOrganizationA2pSiteAddressSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddress>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationA2pSiteAddressSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 400: invalid address, or details.reason KIND_UNAVAILABLE (that site type has no domain yet). 409 details.reason: LOCKED (campaign submitted or approved), TAKEN / INVALID (address not available), KIND_LOCKED (a borrowed campaign fixes the site type), KIND_UNAVAILABLE (the saved type has no domain yet), or ONLINE_BOOKING_ON (changing the site type to Restaurant while Hayven online booking is on: restaurants never use it, so the owner turns it off first).
 * @summary Set the texting-compliance website address and site type (admin-equivalent; locked while the A2P campaign is submitted or approved)
 */
export const patchOrganizationA2pSiteAddress = (
  patchOrganizationA2pSiteAddressBody: PatchOrganizationA2pSiteAddressBody
) => {
  return customInstance<PatchOrganizationA2pSiteAddress200>({
    url: `/organization/a2p-site-address`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchOrganizationA2pSiteAddressBody,
  });
};

export const getPatchOrganizationA2pSiteAddressMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOrganizationA2pSiteAddress>>,
    TError,
    { data: PatchOrganizationA2pSiteAddressBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchOrganizationA2pSiteAddress>>,
  TError,
  { data: PatchOrganizationA2pSiteAddressBody },
  TContext
> => {
  const mutationKey = ['patchOrganizationA2pSiteAddress'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchOrganizationA2pSiteAddress>>,
    { data: PatchOrganizationA2pSiteAddressBody }
  > = (props) => {
    const { data } = props ?? {};

    return patchOrganizationA2pSiteAddress(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchOrganizationA2pSiteAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchOrganizationA2pSiteAddress>>
>;
export type PatchOrganizationA2pSiteAddressMutationBody = PatchOrganizationA2pSiteAddressBody;
export type PatchOrganizationA2pSiteAddressMutationError = unknown;

/**
 * @summary Set the texting-compliance website address and site type (admin-equivalent; locked while the A2P campaign is submitted or approved)
 */
export const usePatchOrganizationA2pSiteAddress = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchOrganizationA2pSiteAddress>>,
      TError,
      { data: PatchOrganizationA2pSiteAddressBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchOrganizationA2pSiteAddress>>,
  TError,
  { data: PatchOrganizationA2pSiteAddressBody },
  TContext
> => {
  const mutationOptions = getPatchOrganizationA2pSiteAddressMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Check whether a compliance website address label is valid and free
 */
export const getOrganizationA2pSiteAddressAvailability = (
  params: GetOrganizationA2pSiteAddressAvailabilityParams,
  signal?: AbortSignal
) => {
  return customInstance<GetOrganizationA2pSiteAddressAvailability200>({
    url: `/organization/a2p-site-address/availability`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetOrganizationA2pSiteAddressAvailabilityInfiniteQueryKey = (
  params?: GetOrganizationA2pSiteAddressAvailabilityParams
) => {
  return [
    'infinite',
    `/organization/a2p-site-address/availability`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetOrganizationA2pSiteAddressAvailabilityQueryKey = (
  params?: GetOrganizationA2pSiteAddressAvailabilityParams
) => {
  return [`/organization/a2p-site-address/availability`, ...(params ? [params] : [])] as const;
};

export const getGetOrganizationA2pSiteAddressAvailabilityInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>>,
  TError = unknown,
>(
  params: GetOrganizationA2pSiteAddressAvailabilityParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationA2pSiteAddressAvailabilityInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>
  > = ({ signal }) => getOrganizationA2pSiteAddressAvailability(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationA2pSiteAddressAvailabilityInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>
>;
export type GetOrganizationA2pSiteAddressAvailabilityInfiniteQueryError = unknown;

export function useGetOrganizationA2pSiteAddressAvailabilityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>>,
  TError = unknown,
>(
  params: GetOrganizationA2pSiteAddressAvailabilityParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationA2pSiteAddressAvailabilityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>>,
  TError = unknown,
>(
  params: GetOrganizationA2pSiteAddressAvailabilityParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationA2pSiteAddressAvailabilityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>>,
  TError = unknown,
>(
  params: GetOrganizationA2pSiteAddressAvailabilityParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Check whether a compliance website address label is valid and free
 */

export function useGetOrganizationA2pSiteAddressAvailabilityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>>,
  TError = unknown,
>(
  params: GetOrganizationA2pSiteAddressAvailabilityParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationA2pSiteAddressAvailabilityInfiniteQueryOptions(
    params,
    options
  );

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationA2pSiteAddressAvailabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationA2pSiteAddressAvailabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationA2pSiteAddressAvailabilityQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>
  > = ({ signal }) => getOrganizationA2pSiteAddressAvailability(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationA2pSiteAddressAvailabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>
>;
export type GetOrganizationA2pSiteAddressAvailabilityQueryError = unknown;

export function useGetOrganizationA2pSiteAddressAvailability<
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationA2pSiteAddressAvailabilityParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationA2pSiteAddressAvailability<
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationA2pSiteAddressAvailabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationA2pSiteAddressAvailability<
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationA2pSiteAddressAvailabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Check whether a compliance website address label is valid and free
 */

export function useGetOrganizationA2pSiteAddressAvailability<
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationA2pSiteAddressAvailabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationA2pSiteAddressAvailabilityQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationA2pSiteAddressAvailabilitySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationA2pSiteAddressAvailabilityParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationA2pSiteAddressAvailabilityQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>
  > = ({ signal }) => getOrganizationA2pSiteAddressAvailability(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationA2pSiteAddressAvailabilitySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>
>;
export type GetOrganizationA2pSiteAddressAvailabilitySuspenseQueryError = unknown;

export function useGetOrganizationA2pSiteAddressAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationA2pSiteAddressAvailabilityParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationA2pSiteAddressAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationA2pSiteAddressAvailabilityParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationA2pSiteAddressAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationA2pSiteAddressAvailabilityParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Check whether a compliance website address label is valid and free
 */

export function useGetOrganizationA2pSiteAddressAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
  TError = unknown,
>(
  params: GetOrganizationA2pSiteAddressAvailabilityParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationA2pSiteAddressAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationA2pSiteAddressAvailabilitySuspenseQueryOptions(
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Set how the salon uses Hayven (owners may only choose alongside their POS)
 */
export const patchOrganizationPointOfSaleMode = (
  patchOrganizationPointOfSaleModeBody: PatchOrganizationPointOfSaleModeBody
) => {
  return customInstance<PatchOrganizationPointOfSaleMode200>({
    url: `/organization/point-of-sale-mode`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchOrganizationPointOfSaleModeBody,
  });
};

export const getPatchOrganizationPointOfSaleModeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOrganizationPointOfSaleMode>>,
    TError,
    { data: PatchOrganizationPointOfSaleModeBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchOrganizationPointOfSaleMode>>,
  TError,
  { data: PatchOrganizationPointOfSaleModeBody },
  TContext
> => {
  const mutationKey = ['patchOrganizationPointOfSaleMode'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchOrganizationPointOfSaleMode>>,
    { data: PatchOrganizationPointOfSaleModeBody }
  > = (props) => {
    const { data } = props ?? {};

    return patchOrganizationPointOfSaleMode(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchOrganizationPointOfSaleModeMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchOrganizationPointOfSaleMode>>
>;
export type PatchOrganizationPointOfSaleModeMutationBody = PatchOrganizationPointOfSaleModeBody;
export type PatchOrganizationPointOfSaleModeMutationError = unknown;

/**
 * @summary Set how the salon uses Hayven (owners may only choose alongside their POS)
 */
export const usePatchOrganizationPointOfSaleMode = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchOrganizationPointOfSaleMode>>,
      TError,
      { data: PatchOrganizationPointOfSaleModeBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchOrganizationPointOfSaleMode>>,
  TError,
  { data: PatchOrganizationPointOfSaleModeBody },
  TContext
> => {
  const mutationOptions = getPatchOrganizationPointOfSaleModeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Set where clients check in: on Hayven, or on the salon’s own POS
 */
export const patchOrganizationCheckInMode = (
  patchOrganizationCheckInModeBody: PatchOrganizationCheckInModeBody
) => {
  return customInstance<PatchOrganizationCheckInMode200>({
    url: `/organization/check-in-mode`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchOrganizationCheckInModeBody,
  });
};

export const getPatchOrganizationCheckInModeMutationOptions = <
  TError = CheckInModeNotAvailableError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOrganizationCheckInMode>>,
    TError,
    { data: PatchOrganizationCheckInModeBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchOrganizationCheckInMode>>,
  TError,
  { data: PatchOrganizationCheckInModeBody },
  TContext
> => {
  const mutationKey = ['patchOrganizationCheckInMode'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchOrganizationCheckInMode>>,
    { data: PatchOrganizationCheckInModeBody }
  > = (props) => {
    const { data } = props ?? {};

    return patchOrganizationCheckInMode(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchOrganizationCheckInModeMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchOrganizationCheckInMode>>
>;
export type PatchOrganizationCheckInModeMutationBody = PatchOrganizationCheckInModeBody;
export type PatchOrganizationCheckInModeMutationError = CheckInModeNotAvailableError;

/**
 * @summary Set where clients check in: on Hayven, or on the salon’s own POS
 */
export const usePatchOrganizationCheckInMode = <
  TError = CheckInModeNotAvailableError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchOrganizationCheckInMode>>,
      TError,
      { data: PatchOrganizationCheckInModeBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchOrganizationCheckInMode>>,
  TError,
  { data: PatchOrganizationCheckInModeBody },
  TContext
> => {
  const mutationOptions = getPatchOrganizationCheckInModeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Only the add-ons named change. Calendar on points the booking link at the Hayven booking page and turns online booking on when the booking page is ready; Calendar off turns online booking and No-show protection off (upcoming bookings and their reminders stay). Check-in needs Calendar or Turns, so turning both off turns it off too. Check-in off turns No-show protection off. `forced` lists what moved with the add-ons. Repeating the current setup changes nothing.
 * @summary Change the add-ons Hayven runs next to the salon’s POS (Calendar, Turns, Check-in)
 */
export const patchOrganizationSetup = (salonAddOnsChange: SalonAddOnsChange) => {
  return customInstance<PatchOrganizationSetup200>({
    url: `/organization/setup`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: salonAddOnsChange,
  });
};

export const getPatchOrganizationSetupMutationOptions = <
  TError = SalonSetupRefusalError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOrganizationSetup>>,
    TError,
    { data: SalonAddOnsChange },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchOrganizationSetup>>,
  TError,
  { data: SalonAddOnsChange },
  TContext
> => {
  const mutationKey = ['patchOrganizationSetup'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchOrganizationSetup>>,
    { data: SalonAddOnsChange }
  > = (props) => {
    const { data } = props ?? {};

    return patchOrganizationSetup(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchOrganizationSetupMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchOrganizationSetup>>
>;
export type PatchOrganizationSetupMutationBody = SalonAddOnsChange;
export type PatchOrganizationSetupMutationError = SalonSetupRefusalError;

/**
 * @summary Change the add-ons Hayven runs next to the salon’s POS (Calendar, Turns, Check-in)
 */
export const usePatchOrganizationSetup = <TError = SalonSetupRefusalError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchOrganizationSetup>>,
      TError,
      { data: SalonAddOnsChange },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchOrganizationSetup>>,
  TError,
  { data: SalonAddOnsChange },
  TContext
> => {
  const mutationOptions = getPatchOrganizationSetupMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary What a setup change keeps, moves or turns off (for the confirm step)
 */
export const getOrganizationSetupChangeContext = (signal?: AbortSignal) => {
  return customInstance<GetOrganizationSetupChangeContext200>({
    url: `/organization/setup/change-context`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationSetupChangeContextInfiniteQueryKey = () => {
  return ['infinite', `/organization/setup/change-context`] as const;
};

export const getGetOrganizationSetupChangeContextQueryKey = () => {
  return [`/organization/setup/change-context`] as const;
};

export const getGetOrganizationSetupChangeContextInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationSetupChangeContextInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>> = ({
    signal,
  }) => getOrganizationSetupChangeContext(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationSetupChangeContextInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>
>;
export type GetOrganizationSetupChangeContextInfiniteQueryError = unknown;

export function useGetOrganizationSetupChangeContextInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSetupChangeContextInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSetupChangeContextInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary What a setup change keeps, moves or turns off (for the confirm step)
 */

export function useGetOrganizationSetupChangeContextInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationSetupChangeContextInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationSetupChangeContextQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationSetupChangeContextQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>> = ({
    signal,
  }) => getOrganizationSetupChangeContext(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationSetupChangeContextQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>
>;
export type GetOrganizationSetupChangeContextQueryError = unknown;

export function useGetOrganizationSetupChangeContext<
  TData = Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSetupChangeContext<
  TData = Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSetupChangeContext<
  TData = Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary What a setup change keeps, moves or turns off (for the confirm step)
 */

export function useGetOrganizationSetupChangeContext<
  TData = Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationSetupChangeContextQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationSetupChangeContextSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationSetupChangeContextQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>> = ({
    signal,
  }) => getOrganizationSetupChangeContext(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationSetupChangeContextSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>
>;
export type GetOrganizationSetupChangeContextSuspenseQueryError = unknown;

export function useGetOrganizationSetupChangeContextSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSetupChangeContextSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSetupChangeContextSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary What a setup change keeps, moves or turns off (for the confirm step)
 */

export function useGetOrganizationSetupChangeContextSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSetupChangeContext>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationSetupChangeContextSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get check-in settings (kiosk / QR)
 */
export const getOrganizationCheckInSettings = (signal?: AbortSignal) => {
  return customInstance<GetOrganizationCheckInSettings200>({
    url: `/organization/check-in-settings`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationCheckInSettingsInfiniteQueryKey = () => {
  return ['infinite', `/organization/check-in-settings`] as const;
};

export const getGetOrganizationCheckInSettingsQueryKey = () => {
  return [`/organization/check-in-settings`] as const;
};

export const getGetOrganizationCheckInSettingsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCheckInSettings>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationCheckInSettingsInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationCheckInSettings>>> = ({
    signal,
  }) => getOrganizationCheckInSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationCheckInSettingsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationCheckInSettings>>
>;
export type GetOrganizationCheckInSettingsInfiniteQueryError = unknown;

export function useGetOrganizationCheckInSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCheckInSettings>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCheckInSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCheckInSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCheckInSettings>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCheckInSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCheckInSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCheckInSettings>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get check-in settings (kiosk / QR)
 */

export function useGetOrganizationCheckInSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCheckInSettings>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationCheckInSettingsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationCheckInSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizationCheckInSettings>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationCheckInSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationCheckInSettings>>> = ({
    signal,
  }) => getOrganizationCheckInSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationCheckInSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationCheckInSettings>>
>;
export type GetOrganizationCheckInSettingsQueryError = unknown;

export function useGetOrganizationCheckInSettings<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationCheckInSettings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCheckInSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCheckInSettings<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationCheckInSettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCheckInSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCheckInSettings<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationCheckInSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get check-in settings (kiosk / QR)
 */

export function useGetOrganizationCheckInSettings<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationCheckInSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationCheckInSettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationCheckInSettingsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationCheckInSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationCheckInSettings>>> = ({
    signal,
  }) => getOrganizationCheckInSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationCheckInSettingsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationCheckInSettings>>
>;
export type GetOrganizationCheckInSettingsSuspenseQueryError = unknown;

export function useGetOrganizationCheckInSettingsSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCheckInSettingsSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCheckInSettingsSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get check-in settings (kiosk / QR)
 */

export function useGetOrganizationCheckInSettingsSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationCheckInSettingsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The on/off switch (isEnabled) is the Check-in add-on (same rules as PATCH /organization/setup) and needs administrator access whether the add-on launch gate is open or closed; the other fields keep settings access. With the gate open only the refusals of the add-on switch itself apply (CHECK_IN_NO_DESTINATION; CHECK_IN_MODE_NOT_AVAILABLE for turning it off while Hayven is the POS). Until then: turning check-in off is 409 CHECK_IN_LOCKED while Online Booking is on, and 409 SETUP_NOT_AVAILABLE_YET while Calendar is on. Turning it on is 409 CHECK_IN_NO_DESTINATION while Calendar and Turns are both off, and 409 CHECK_IN_MODE_POS while the salon checks clients in on its own POS. autoNoShow (the retired Mark Done) is accepted and ignored. A LIVE New Client Offer never locks it: its guests use the counter QR.
 * @summary Update check-in settings (turning it on stamps enabledAt)
 */
export const patchOrganizationCheckInSettings = (updateCheckInSettings: UpdateCheckInSettings) => {
  return customInstance<PatchOrganizationCheckInSettings200>({
    url: `/organization/check-in-settings`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateCheckInSettings,
  });
};

export const getPatchOrganizationCheckInSettingsMutationOptions = <
  TError = PatchOrganizationCheckInSettings409,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOrganizationCheckInSettings>>,
    TError,
    { data: UpdateCheckInSettings },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchOrganizationCheckInSettings>>,
  TError,
  { data: UpdateCheckInSettings },
  TContext
> => {
  const mutationKey = ['patchOrganizationCheckInSettings'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchOrganizationCheckInSettings>>,
    { data: UpdateCheckInSettings }
  > = (props) => {
    const { data } = props ?? {};

    return patchOrganizationCheckInSettings(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchOrganizationCheckInSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchOrganizationCheckInSettings>>
>;
export type PatchOrganizationCheckInSettingsMutationBody = UpdateCheckInSettings;
export type PatchOrganizationCheckInSettingsMutationError = PatchOrganizationCheckInSettings409;

/**
 * @summary Update check-in settings (turning it on stamps enabledAt)
 */
export const usePatchOrganizationCheckInSettings = <
  TError = PatchOrganizationCheckInSettings409,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchOrganizationCheckInSettings>>,
      TError,
      { data: UpdateCheckInSettings },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchOrganizationCheckInSettings>>,
  TError,
  { data: UpdateCheckInSettings },
  TContext
> => {
  const mutationOptions = getPatchOrganizationCheckInSettingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Set the PIN that unlocks kiosk mode on the front-desk iPad
 */
export const putOrganizationCheckInSettingsExitPin = (setCheckInExitPin: SetCheckInExitPin) => {
  return customInstance<PutOrganizationCheckInSettingsExitPin200>({
    url: `/organization/check-in-settings/exit-pin`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: setCheckInExitPin,
  });
};

export const getPutOrganizationCheckInSettingsExitPinMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putOrganizationCheckInSettingsExitPin>>,
    TError,
    { data: SetCheckInExitPin },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putOrganizationCheckInSettingsExitPin>>,
  TError,
  { data: SetCheckInExitPin },
  TContext
> => {
  const mutationKey = ['putOrganizationCheckInSettingsExitPin'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putOrganizationCheckInSettingsExitPin>>,
    { data: SetCheckInExitPin }
  > = (props) => {
    const { data } = props ?? {};

    return putOrganizationCheckInSettingsExitPin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutOrganizationCheckInSettingsExitPinMutationResult = NonNullable<
  Awaited<ReturnType<typeof putOrganizationCheckInSettingsExitPin>>
>;
export type PutOrganizationCheckInSettingsExitPinMutationBody = SetCheckInExitPin;
export type PutOrganizationCheckInSettingsExitPinMutationError = unknown;

/**
 * @summary Set the PIN that unlocks kiosk mode on the front-desk iPad
 */
export const usePutOrganizationCheckInSettingsExitPin = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putOrganizationCheckInSettingsExitPin>>,
      TError,
      { data: SetCheckInExitPin },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putOrganizationCheckInSettingsExitPin>>,
  TError,
  { data: SetCheckInExitPin },
  TContext
> => {
  const mutationOptions = getPutOrganizationCheckInSettingsExitPinMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Invalidate every printed check-in QR poster (new poster key)
 */
export const postOrganizationCheckInSettingsRotatePoster = (signal?: AbortSignal) => {
  return customInstance<PostOrganizationCheckInSettingsRotatePoster200>({
    url: `/organization/check-in-settings/rotate-poster`,
    method: 'POST',
    signal,
  });
};

export const getPostOrganizationCheckInSettingsRotatePosterMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrganizationCheckInSettingsRotatePoster>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrganizationCheckInSettingsRotatePoster>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postOrganizationCheckInSettingsRotatePoster'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrganizationCheckInSettingsRotatePoster>>,
    void
  > = () => {
    return postOrganizationCheckInSettingsRotatePoster();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostOrganizationCheckInSettingsRotatePosterMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrganizationCheckInSettingsRotatePoster>>
>;

export type PostOrganizationCheckInSettingsRotatePosterMutationError = unknown;

/**
 * @summary Invalidate every printed check-in QR poster (new poster key)
 */
export const usePostOrganizationCheckInSettingsRotatePoster = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrganizationCheckInSettingsRotatePoster>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postOrganizationCheckInSettingsRotatePoster>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostOrganizationCheckInSettingsRotatePosterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Add a check-in kiosk and get its one-time pairing code (10 min)
 */
export const postOrganizationKioskDevices = (
  createKioskDevice: CreateKioskDevice,
  signal?: AbortSignal
) => {
  return customInstance<PostOrganizationKioskDevices201>({
    url: `/organization/kiosk-devices`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createKioskDevice,
    signal,
  });
};

export const getPostOrganizationKioskDevicesMutationOptions = <
  TError = PostOrganizationKioskDevices409,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrganizationKioskDevices>>,
    TError,
    { data: CreateKioskDevice },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrganizationKioskDevices>>,
  TError,
  { data: CreateKioskDevice },
  TContext
> => {
  const mutationKey = ['postOrganizationKioskDevices'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrganizationKioskDevices>>,
    { data: CreateKioskDevice }
  > = (props) => {
    const { data } = props ?? {};

    return postOrganizationKioskDevices(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostOrganizationKioskDevicesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrganizationKioskDevices>>
>;
export type PostOrganizationKioskDevicesMutationBody = CreateKioskDevice;
export type PostOrganizationKioskDevicesMutationError = PostOrganizationKioskDevices409;

/**
 * @summary Add a check-in kiosk and get its one-time pairing code (10 min)
 */
export const usePostOrganizationKioskDevices = <
  TError = PostOrganizationKioskDevices409,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrganizationKioskDevices>>,
      TError,
      { data: CreateKioskDevice },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postOrganizationKioskDevices>>,
  TError,
  { data: CreateKioskDevice },
  TContext
> => {
  const mutationOptions = getPostOrganizationKioskDevicesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary List check-in kiosks (revoked ones hidden)
 */
export const getOrganizationKioskDevices = (signal?: AbortSignal) => {
  return customInstance<GetOrganizationKioskDevices200>({
    url: `/organization/kiosk-devices`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationKioskDevicesInfiniteQueryKey = () => {
  return ['infinite', `/organization/kiosk-devices`] as const;
};

export const getGetOrganizationKioskDevicesQueryKey = () => {
  return [`/organization/kiosk-devices`] as const;
};

export const getGetOrganizationKioskDevicesInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationKioskDevices>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationKioskDevices>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationKioskDevicesInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationKioskDevices>>> = ({
    signal,
  }) => getOrganizationKioskDevices(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationKioskDevicesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationKioskDevices>>
>;
export type GetOrganizationKioskDevicesInfiniteQueryError = unknown;

export function useGetOrganizationKioskDevicesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationKioskDevices>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationKioskDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationKioskDevicesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationKioskDevices>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationKioskDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationKioskDevicesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationKioskDevices>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List check-in kiosks (revoked ones hidden)
 */

export function useGetOrganizationKioskDevicesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationKioskDevices>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationKioskDevicesInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationKioskDevicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizationKioskDevices>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationKioskDevicesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationKioskDevices>>> = ({
    signal,
  }) => getOrganizationKioskDevices(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationKioskDevicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationKioskDevices>>
>;
export type GetOrganizationKioskDevicesQueryError = unknown;

export function useGetOrganizationKioskDevices<
  TData = Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationKioskDevices>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationKioskDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationKioskDevices<
  TData = Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationKioskDevices>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationKioskDevices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationKioskDevices<
  TData = Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationKioskDevices>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List check-in kiosks (revoked ones hidden)
 */

export function useGetOrganizationKioskDevices<
  TData = Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationKioskDevices>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationKioskDevicesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationKioskDevicesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationKioskDevices>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationKioskDevicesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationKioskDevices>>> = ({
    signal,
  }) => getOrganizationKioskDevices(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationKioskDevicesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationKioskDevices>>
>;
export type GetOrganizationKioskDevicesSuspenseQueryError = unknown;

export function useGetOrganizationKioskDevicesSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationKioskDevicesSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationKioskDevicesSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List check-in kiosks (revoked ones hidden)
 */

export function useGetOrganizationKioskDevicesSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationKioskDevices>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationKioskDevicesSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Revoke a check-in kiosk (it stops working immediately)
 */
export const deleteOrganizationKioskDevicesId = (id: string) => {
  return customInstance<DeleteOrganizationKioskDevicesId200>({
    url: `/organization/kiosk-devices/${id}`,
    method: 'DELETE',
  });
};

export const getDeleteOrganizationKioskDevicesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrganizationKioskDevicesId>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOrganizationKioskDevicesId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteOrganizationKioskDevicesId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOrganizationKioskDevicesId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteOrganizationKioskDevicesId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOrganizationKioskDevicesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOrganizationKioskDevicesId>>
>;

export type DeleteOrganizationKioskDevicesIdMutationError = unknown;

/**
 * @summary Revoke a check-in kiosk (it stops working immediately)
 */
export const useDeleteOrganizationKioskDevicesId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteOrganizationKioskDevicesId>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteOrganizationKioskDevicesId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteOrganizationKioskDevicesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Printed check-in QR poster link per location
 */
export const getOrganizationCheckInSettingsPosterLinks = (signal?: AbortSignal) => {
  return customInstance<GetOrganizationCheckInSettingsPosterLinks200>({
    url: `/organization/check-in-settings/poster-links`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationCheckInSettingsPosterLinksInfiniteQueryKey = () => {
  return ['infinite', `/organization/check-in-settings/poster-links`] as const;
};

export const getGetOrganizationCheckInSettingsPosterLinksQueryKey = () => {
  return [`/organization/check-in-settings/poster-links`] as const;
};

export const getGetOrganizationCheckInSettingsPosterLinksInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationCheckInSettingsPosterLinksInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>
  > = ({ signal }) => getOrganizationCheckInSettingsPosterLinks(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationCheckInSettingsPosterLinksInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>
>;
export type GetOrganizationCheckInSettingsPosterLinksInfiniteQueryError = unknown;

export function useGetOrganizationCheckInSettingsPosterLinksInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCheckInSettingsPosterLinksInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCheckInSettingsPosterLinksInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Printed check-in QR poster link per location
 */

export function useGetOrganizationCheckInSettingsPosterLinksInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationCheckInSettingsPosterLinksInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationCheckInSettingsPosterLinksQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationCheckInSettingsPosterLinksQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>
  > = ({ signal }) => getOrganizationCheckInSettingsPosterLinks(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationCheckInSettingsPosterLinksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>
>;
export type GetOrganizationCheckInSettingsPosterLinksQueryError = unknown;

export function useGetOrganizationCheckInSettingsPosterLinks<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCheckInSettingsPosterLinks<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCheckInSettingsPosterLinks<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Printed check-in QR poster link per location
 */

export function useGetOrganizationCheckInSettingsPosterLinks<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationCheckInSettingsPosterLinksQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationCheckInSettingsPosterLinksSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationCheckInSettingsPosterLinksQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>
  > = ({ signal }) => getOrganizationCheckInSettingsPosterLinks(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationCheckInSettingsPosterLinksSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>
>;
export type GetOrganizationCheckInSettingsPosterLinksSuspenseQueryError = unknown;

export function useGetOrganizationCheckInSettingsPosterLinksSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCheckInSettingsPosterLinksSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCheckInSettingsPosterLinksSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Printed check-in QR poster link per location
 */

export function useGetOrganizationCheckInSettingsPosterLinksSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterLinks>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationCheckInSettingsPosterLinksSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download the check-in QR poster (PDF)
 */
export const getOrganizationCheckInSettingsPosterPdf = (
  params?: GetOrganizationCheckInSettingsPosterPdfParams,
  signal?: AbortSignal
) => {
  return customInstance<Blob>({
    url: `/organization/check-in-settings/poster.pdf`,
    method: 'GET',
    params,
    responseType: 'blob',
    signal,
  });
};

export const getGetOrganizationCheckInSettingsPosterPdfInfiniteQueryKey = (
  params?: GetOrganizationCheckInSettingsPosterPdfParams
) => {
  return [
    'infinite',
    `/organization/check-in-settings/poster.pdf`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetOrganizationCheckInSettingsPosterPdfQueryKey = (
  params?: GetOrganizationCheckInSettingsPosterPdfParams
) => {
  return [`/organization/check-in-settings/poster.pdf`, ...(params ? [params] : [])] as const;
};

export const getGetOrganizationCheckInSettingsPosterPdfInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>>,
  TError = GetOrganizationCheckInSettingsPosterPdf409,
>(
  params?: GetOrganizationCheckInSettingsPosterPdfParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationCheckInSettingsPosterPdfInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>
  > = ({ signal }) => getOrganizationCheckInSettingsPosterPdf(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationCheckInSettingsPosterPdfInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>
>;
export type GetOrganizationCheckInSettingsPosterPdfInfiniteQueryError =
  GetOrganizationCheckInSettingsPosterPdf409;

export function useGetOrganizationCheckInSettingsPosterPdfInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>>,
  TError = GetOrganizationCheckInSettingsPosterPdf409,
>(
  params: undefined | GetOrganizationCheckInSettingsPosterPdfParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCheckInSettingsPosterPdfInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>>,
  TError = GetOrganizationCheckInSettingsPosterPdf409,
>(
  params?: GetOrganizationCheckInSettingsPosterPdfParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCheckInSettingsPosterPdfInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>>,
  TError = GetOrganizationCheckInSettingsPosterPdf409,
>(
  params?: GetOrganizationCheckInSettingsPosterPdfParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Download the check-in QR poster (PDF)
 */

export function useGetOrganizationCheckInSettingsPosterPdfInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>>,
  TError = GetOrganizationCheckInSettingsPosterPdf409,
>(
  params?: GetOrganizationCheckInSettingsPosterPdfParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationCheckInSettingsPosterPdfInfiniteQueryOptions(
    params,
    options
  );

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationCheckInSettingsPosterPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
  TError = GetOrganizationCheckInSettingsPosterPdf409,
>(
  params?: GetOrganizationCheckInSettingsPosterPdfParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationCheckInSettingsPosterPdfQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>
  > = ({ signal }) => getOrganizationCheckInSettingsPosterPdf(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationCheckInSettingsPosterPdfQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>
>;
export type GetOrganizationCheckInSettingsPosterPdfQueryError =
  GetOrganizationCheckInSettingsPosterPdf409;

export function useGetOrganizationCheckInSettingsPosterPdf<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
  TError = GetOrganizationCheckInSettingsPosterPdf409,
>(
  params: undefined | GetOrganizationCheckInSettingsPosterPdfParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCheckInSettingsPosterPdf<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
  TError = GetOrganizationCheckInSettingsPosterPdf409,
>(
  params?: GetOrganizationCheckInSettingsPosterPdfParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCheckInSettingsPosterPdf<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
  TError = GetOrganizationCheckInSettingsPosterPdf409,
>(
  params?: GetOrganizationCheckInSettingsPosterPdfParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Download the check-in QR poster (PDF)
 */

export function useGetOrganizationCheckInSettingsPosterPdf<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
  TError = GetOrganizationCheckInSettingsPosterPdf409,
>(
  params?: GetOrganizationCheckInSettingsPosterPdfParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationCheckInSettingsPosterPdfQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationCheckInSettingsPosterPdfSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
  TError = GetOrganizationCheckInSettingsPosterPdf409,
>(
  params?: GetOrganizationCheckInSettingsPosterPdfParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationCheckInSettingsPosterPdfQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>
  > = ({ signal }) => getOrganizationCheckInSettingsPosterPdf(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationCheckInSettingsPosterPdfSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>
>;
export type GetOrganizationCheckInSettingsPosterPdfSuspenseQueryError =
  GetOrganizationCheckInSettingsPosterPdf409;

export function useGetOrganizationCheckInSettingsPosterPdfSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
  TError = GetOrganizationCheckInSettingsPosterPdf409,
>(
  params: undefined | GetOrganizationCheckInSettingsPosterPdfParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCheckInSettingsPosterPdfSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
  TError = GetOrganizationCheckInSettingsPosterPdf409,
>(
  params?: GetOrganizationCheckInSettingsPosterPdfParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationCheckInSettingsPosterPdfSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
  TError = GetOrganizationCheckInSettingsPosterPdf409,
>(
  params?: GetOrganizationCheckInSettingsPosterPdfParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Download the check-in QR poster (PDF)
 */

export function useGetOrganizationCheckInSettingsPosterPdfSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
  TError = GetOrganizationCheckInSettingsPosterPdf409,
>(
  params?: GetOrganizationCheckInSettingsPosterPdfParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationCheckInSettingsPosterPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationCheckInSettingsPosterPdfSuspenseQueryOptions(
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Salon setup checklist (Get started): self-checking steps and sidebar visibility
 */
export const getOrganizationSetupGuide = (signal?: AbortSignal) => {
  return customInstance<GetOrganizationSetupGuide200>({
    url: `/organization/setup-guide`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationSetupGuideInfiniteQueryKey = () => {
  return ['infinite', `/organization/setup-guide`] as const;
};

export const getGetOrganizationSetupGuideQueryKey = () => {
  return [`/organization/setup-guide`] as const;
};

export const getGetOrganizationSetupGuideInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSetupGuide>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupGuide>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationSetupGuideInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationSetupGuide>>> = ({
    signal,
  }) => getOrganizationSetupGuide(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSetupGuide>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationSetupGuideInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationSetupGuide>>
>;
export type GetOrganizationSetupGuideInfiniteQueryError = unknown;

export function useGetOrganizationSetupGuideInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSetupGuide>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupGuide>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSetupGuide>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSetupGuide>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSetupGuideInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSetupGuide>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupGuide>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSetupGuide>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSetupGuide>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSetupGuideInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSetupGuide>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupGuide>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Salon setup checklist (Get started): self-checking steps and sidebar visibility
 */

export function useGetOrganizationSetupGuideInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationSetupGuide>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupGuide>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationSetupGuideInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationSetupGuideQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationSetupGuide>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupGuide>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationSetupGuideQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationSetupGuide>>> = ({
    signal,
  }) => getOrganizationSetupGuide(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSetupGuide>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationSetupGuideQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationSetupGuide>>
>;
export type GetOrganizationSetupGuideQueryError = unknown;

export function useGetOrganizationSetupGuide<
  TData = Awaited<ReturnType<typeof getOrganizationSetupGuide>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupGuide>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSetupGuide>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSetupGuide>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSetupGuide<
  TData = Awaited<ReturnType<typeof getOrganizationSetupGuide>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupGuide>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSetupGuide>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSetupGuide>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSetupGuide<
  TData = Awaited<ReturnType<typeof getOrganizationSetupGuide>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupGuide>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Salon setup checklist (Get started): self-checking steps and sidebar visibility
 */

export function useGetOrganizationSetupGuide<
  TData = Awaited<ReturnType<typeof getOrganizationSetupGuide>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupGuide>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationSetupGuideQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationSetupGuideSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationSetupGuide>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupGuide>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationSetupGuideQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationSetupGuide>>> = ({
    signal,
  }) => getOrganizationSetupGuide(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSetupGuide>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationSetupGuideSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationSetupGuide>>
>;
export type GetOrganizationSetupGuideSuspenseQueryError = unknown;

export function useGetOrganizationSetupGuideSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSetupGuide>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupGuide>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSetupGuideSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSetupGuide>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupGuide>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSetupGuideSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSetupGuide>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupGuide>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Salon setup checklist (Get started): self-checking steps and sidebar visibility
 */

export function useGetOrganizationSetupGuideSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationSetupGuide>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationSetupGuide>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationSetupGuideSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Hide or show the Get started page in the sidebar (salon-wide)
 */
export const putOrganizationSetupGuide = (
  putOrganizationSetupGuideBody: PutOrganizationSetupGuideBody
) => {
  return customInstance<PutOrganizationSetupGuide200>({
    url: `/organization/setup-guide`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putOrganizationSetupGuideBody,
  });
};

export const getPutOrganizationSetupGuideMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putOrganizationSetupGuide>>,
    TError,
    { data: PutOrganizationSetupGuideBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putOrganizationSetupGuide>>,
  TError,
  { data: PutOrganizationSetupGuideBody },
  TContext
> => {
  const mutationKey = ['putOrganizationSetupGuide'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putOrganizationSetupGuide>>,
    { data: PutOrganizationSetupGuideBody }
  > = (props) => {
    const { data } = props ?? {};

    return putOrganizationSetupGuide(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutOrganizationSetupGuideMutationResult = NonNullable<
  Awaited<ReturnType<typeof putOrganizationSetupGuide>>
>;
export type PutOrganizationSetupGuideMutationBody = PutOrganizationSetupGuideBody;
export type PutOrganizationSetupGuideMutationError = unknown;

/**
 * @summary Hide or show the Get started page in the sidebar (salon-wide)
 */
export const usePutOrganizationSetupGuide = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putOrganizationSetupGuide>>,
      TError,
      { data: PutOrganizationSetupGuideBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putOrganizationSetupGuide>>,
  TError,
  { data: PutOrganizationSetupGuideBody },
  TContext
> => {
  const mutationOptions = getPutOrganizationSetupGuideMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary This salon-local month's pools, overage and spending cap
 */
export const getOrganizationBillingUsage = (signal?: AbortSignal) => {
  return customInstance<GetOrganizationBillingUsage200>({
    url: `/organization/billing/usage`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationBillingUsageInfiniteQueryKey = () => {
  return ['infinite', `/organization/billing/usage`] as const;
};

export const getGetOrganizationBillingUsageQueryKey = () => {
  return [`/organization/billing/usage`] as const;
};

export const getGetOrganizationBillingUsageInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationBillingUsage>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationBillingUsage>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationBillingUsageInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationBillingUsage>>> = ({
    signal,
  }) => getOrganizationBillingUsage(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationBillingUsageInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationBillingUsage>>
>;
export type GetOrganizationBillingUsageInfiniteQueryError = unknown;

export function useGetOrganizationBillingUsageInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationBillingUsage>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationBillingUsage>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationBillingUsageInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationBillingUsage>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationBillingUsage>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationBillingUsageInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationBillingUsage>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary This salon-local month's pools, overage and spending cap
 */

export function useGetOrganizationBillingUsageInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationBillingUsage>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationBillingUsageInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationBillingUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBillingUsage>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationBillingUsageQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationBillingUsage>>> = ({
    signal,
  }) => getOrganizationBillingUsage(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationBillingUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationBillingUsage>>
>;
export type GetOrganizationBillingUsageQueryError = unknown;

export function useGetOrganizationBillingUsage<
  TData = Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBillingUsage>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationBillingUsage>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationBillingUsage<
  TData = Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBillingUsage>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationBillingUsage>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationBillingUsage<
  TData = Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBillingUsage>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary This salon-local month's pools, overage and spending cap
 */

export function useGetOrganizationBillingUsage<
  TData = Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBillingUsage>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationBillingUsageQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationBillingUsageSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationBillingUsage>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationBillingUsageQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationBillingUsage>>> = ({
    signal,
  }) => getOrganizationBillingUsage(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationBillingUsageSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationBillingUsage>>
>;
export type GetOrganizationBillingUsageSuspenseQueryError = unknown;

export function useGetOrganizationBillingUsageSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationBillingUsageSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationBillingUsageSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary This salon-local month's pools, overage and spending cap
 */

export function useGetOrganizationBillingUsageSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationBillingUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationBillingUsageSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Set the salon's monthly spending cap for overage (salon admins only)
 */
export const putOrganizationBillingSpendingCap = (
  putOrganizationBillingSpendingCapBody: PutOrganizationBillingSpendingCapBody
) => {
  return customInstance<PutOrganizationBillingSpendingCap200>({
    url: `/organization/billing/spending-cap`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putOrganizationBillingSpendingCapBody,
  });
};

export const getPutOrganizationBillingSpendingCapMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putOrganizationBillingSpendingCap>>,
    TError,
    { data: PutOrganizationBillingSpendingCapBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putOrganizationBillingSpendingCap>>,
  TError,
  { data: PutOrganizationBillingSpendingCapBody },
  TContext
> => {
  const mutationKey = ['putOrganizationBillingSpendingCap'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putOrganizationBillingSpendingCap>>,
    { data: PutOrganizationBillingSpendingCapBody }
  > = (props) => {
    const { data } = props ?? {};

    return putOrganizationBillingSpendingCap(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutOrganizationBillingSpendingCapMutationResult = NonNullable<
  Awaited<ReturnType<typeof putOrganizationBillingSpendingCap>>
>;
export type PutOrganizationBillingSpendingCapMutationBody = PutOrganizationBillingSpendingCapBody;
export type PutOrganizationBillingSpendingCapMutationError = void;

/**
 * @summary Set the salon's monthly spending cap for overage (salon admins only)
 */
export const usePutOrganizationBillingSpendingCap = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putOrganizationBillingSpendingCap>>,
      TError,
      { data: PutOrganizationBillingSpendingCapBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putOrganizationBillingSpendingCap>>,
  TError,
  { data: PutOrganizationBillingSpendingCapBody },
  TContext
> => {
  const mutationOptions = getPutOrganizationBillingSpendingCapMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary The salon's subscription: renewal, cancel at period end, setup fee, price deal and its price per plan
 */
export const getOrganizationBillingSubscription = (signal?: AbortSignal) => {
  return customInstance<GetOrganizationBillingSubscription200>({
    url: `/organization/billing/subscription`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationBillingSubscriptionInfiniteQueryKey = () => {
  return ['infinite', `/organization/billing/subscription`] as const;
};

export const getGetOrganizationBillingSubscriptionQueryKey = () => {
  return [`/organization/billing/subscription`] as const;
};

export const getGetOrganizationBillingSubscriptionInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationBillingSubscription>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationBillingSubscriptionInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationBillingSubscription>>> = ({
    signal,
  }) => getOrganizationBillingSubscription(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationBillingSubscriptionInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationBillingSubscription>>
>;
export type GetOrganizationBillingSubscriptionInfiniteQueryError = unknown;

export function useGetOrganizationBillingSubscriptionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationBillingSubscription>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationBillingSubscription>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationBillingSubscriptionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationBillingSubscription>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationBillingSubscription>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationBillingSubscriptionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationBillingSubscription>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon's subscription: renewal, cancel at period end, setup fee, price deal and its price per plan
 */

export function useGetOrganizationBillingSubscriptionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationBillingSubscription>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationBillingSubscriptionInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationBillingSubscriptionQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBillingSubscription>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationBillingSubscriptionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationBillingSubscription>>> = ({
    signal,
  }) => getOrganizationBillingSubscription(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationBillingSubscriptionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationBillingSubscription>>
>;
export type GetOrganizationBillingSubscriptionQueryError = unknown;

export function useGetOrganizationBillingSubscription<
  TData = Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBillingSubscription>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationBillingSubscription>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationBillingSubscription<
  TData = Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBillingSubscription>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationBillingSubscription>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationBillingSubscription<
  TData = Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBillingSubscription>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon's subscription: renewal, cancel at period end, setup fee, price deal and its price per plan
 */

export function useGetOrganizationBillingSubscription<
  TData = Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBillingSubscription>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationBillingSubscriptionQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationBillingSubscriptionSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationBillingSubscriptionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationBillingSubscription>>> = ({
    signal,
  }) => getOrganizationBillingSubscription(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationBillingSubscriptionSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationBillingSubscription>>
>;
export type GetOrganizationBillingSubscriptionSuspenseQueryError = unknown;

export function useGetOrganizationBillingSubscriptionSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationBillingSubscriptionSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationBillingSubscriptionSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon's subscription: renewal, cancel at period end, setup fee, price deal and its price per plan
 */

export function useGetOrganizationBillingSubscriptionSuspense<
  TData = Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationBillingSubscription>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationBillingSubscriptionSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Start a paid plan on Stripe Checkout (salon admins only)
 */
export const postOrganizationBillingCheckout = (
  postOrganizationBillingCheckoutBody: PostOrganizationBillingCheckoutBody,
  signal?: AbortSignal
) => {
  return customInstance<PostOrganizationBillingCheckout200>({
    url: `/organization/billing/checkout`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postOrganizationBillingCheckoutBody,
    signal,
  });
};

export const getPostOrganizationBillingCheckoutMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrganizationBillingCheckout>>,
    TError,
    { data: PostOrganizationBillingCheckoutBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrganizationBillingCheckout>>,
  TError,
  { data: PostOrganizationBillingCheckoutBody },
  TContext
> => {
  const mutationKey = ['postOrganizationBillingCheckout'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrganizationBillingCheckout>>,
    { data: PostOrganizationBillingCheckoutBody }
  > = (props) => {
    const { data } = props ?? {};

    return postOrganizationBillingCheckout(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostOrganizationBillingCheckoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrganizationBillingCheckout>>
>;
export type PostOrganizationBillingCheckoutMutationBody = PostOrganizationBillingCheckoutBody;
export type PostOrganizationBillingCheckoutMutationError = void;

/**
 * @summary Start a paid plan on Stripe Checkout (salon admins only)
 */
export const usePostOrganizationBillingCheckout = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrganizationBillingCheckout>>,
      TError,
      { data: PostOrganizationBillingCheckoutBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postOrganizationBillingCheckout>>,
  TError,
  { data: PostOrganizationBillingCheckoutBody },
  TContext
> => {
  const mutationOptions = getPostOrganizationBillingCheckoutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Re-read the salon's subscription from Stripe (after Checkout returns)
 */
export const postOrganizationBillingRefresh = (
  postOrganizationBillingRefreshBody: PostOrganizationBillingRefreshBody,
  signal?: AbortSignal
) => {
  return customInstance<PostOrganizationBillingRefresh200>({
    url: `/organization/billing/refresh`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postOrganizationBillingRefreshBody,
    signal,
  });
};

export const getPostOrganizationBillingRefreshMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrganizationBillingRefresh>>,
    TError,
    { data: PostOrganizationBillingRefreshBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrganizationBillingRefresh>>,
  TError,
  { data: PostOrganizationBillingRefreshBody },
  TContext
> => {
  const mutationKey = ['postOrganizationBillingRefresh'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrganizationBillingRefresh>>,
    { data: PostOrganizationBillingRefreshBody }
  > = (props) => {
    const { data } = props ?? {};

    return postOrganizationBillingRefresh(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostOrganizationBillingRefreshMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrganizationBillingRefresh>>
>;
export type PostOrganizationBillingRefreshMutationBody = PostOrganizationBillingRefreshBody;
export type PostOrganizationBillingRefreshMutationError = unknown;

/**
 * @summary Re-read the salon's subscription from Stripe (after Checkout returns)
 */
export const usePostOrganizationBillingRefresh = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrganizationBillingRefresh>>,
      TError,
      { data: PostOrganizationBillingRefreshBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postOrganizationBillingRefresh>>,
  TError,
  { data: PostOrganizationBillingRefreshBody },
  TContext
> => {
  const mutationOptions = getPostOrganizationBillingRefreshMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Open the Stripe Customer Portal: payment method, invoices, cancel (salon admins only)
 */
export const postOrganizationBillingPortal = (signal?: AbortSignal) => {
  return customInstance<PostOrganizationBillingPortal200>({
    url: `/organization/billing/portal`,
    method: 'POST',
    signal,
  });
};

export const getPostOrganizationBillingPortalMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrganizationBillingPortal>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrganizationBillingPortal>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postOrganizationBillingPortal'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrganizationBillingPortal>>,
    void
  > = () => {
    return postOrganizationBillingPortal();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostOrganizationBillingPortalMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrganizationBillingPortal>>
>;

export type PostOrganizationBillingPortalMutationError = void;

/**
 * @summary Open the Stripe Customer Portal: payment method, invoices, cancel (salon admins only)
 */
export const usePostOrganizationBillingPortal = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrganizationBillingPortal>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postOrganizationBillingPortal>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostOrganizationBillingPortalMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary What a plan change costs today (salon admins only)
 */
export const postOrganizationBillingChangePlanPreview = (
  postOrganizationBillingChangePlanPreviewBody: PostOrganizationBillingChangePlanPreviewBody,
  signal?: AbortSignal
) => {
  return customInstance<PostOrganizationBillingChangePlanPreview200>({
    url: `/organization/billing/change-plan/preview`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postOrganizationBillingChangePlanPreviewBody,
    signal,
  });
};

export const getPostOrganizationBillingChangePlanPreviewMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrganizationBillingChangePlanPreview>>,
    TError,
    { data: PostOrganizationBillingChangePlanPreviewBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrganizationBillingChangePlanPreview>>,
  TError,
  { data: PostOrganizationBillingChangePlanPreviewBody },
  TContext
> => {
  const mutationKey = ['postOrganizationBillingChangePlanPreview'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrganizationBillingChangePlanPreview>>,
    { data: PostOrganizationBillingChangePlanPreviewBody }
  > = (props) => {
    const { data } = props ?? {};

    return postOrganizationBillingChangePlanPreview(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostOrganizationBillingChangePlanPreviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrganizationBillingChangePlanPreview>>
>;
export type PostOrganizationBillingChangePlanPreviewMutationBody =
  PostOrganizationBillingChangePlanPreviewBody;
export type PostOrganizationBillingChangePlanPreviewMutationError = void;

/**
 * @summary What a plan change costs today (salon admins only)
 */
export const usePostOrganizationBillingChangePlanPreview = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrganizationBillingChangePlanPreview>>,
      TError,
      { data: PostOrganizationBillingChangePlanPreviewBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postOrganizationBillingChangePlanPreview>>,
  TError,
  { data: PostOrganizationBillingChangePlanPreviewBody },
  TContext
> => {
  const mutationOptions = getPostOrganizationBillingChangePlanPreviewMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Change the paid plan: upgrades charged now, downgrades credited (salon admins only)
 */
export const postOrganizationBillingChangePlan = (
  postOrganizationBillingChangePlanBody: PostOrganizationBillingChangePlanBody,
  signal?: AbortSignal
) => {
  return customInstance<PostOrganizationBillingChangePlan200>({
    url: `/organization/billing/change-plan`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postOrganizationBillingChangePlanBody,
    signal,
  });
};

export const getPostOrganizationBillingChangePlanMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrganizationBillingChangePlan>>,
    TError,
    { data: PostOrganizationBillingChangePlanBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrganizationBillingChangePlan>>,
  TError,
  { data: PostOrganizationBillingChangePlanBody },
  TContext
> => {
  const mutationKey = ['postOrganizationBillingChangePlan'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrganizationBillingChangePlan>>,
    { data: PostOrganizationBillingChangePlanBody }
  > = (props) => {
    const { data } = props ?? {};

    return postOrganizationBillingChangePlan(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostOrganizationBillingChangePlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrganizationBillingChangePlan>>
>;
export type PostOrganizationBillingChangePlanMutationBody = PostOrganizationBillingChangePlanBody;
export type PostOrganizationBillingChangePlanMutationError = void;

/**
 * @summary Change the paid plan: upgrades charged now, downgrades credited (salon admins only)
 */
export const usePostOrganizationBillingChangePlan = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrganizationBillingChangePlan>>,
      TError,
      { data: PostOrganizationBillingChangePlanBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postOrganizationBillingChangePlan>>,
  TError,
  { data: PostOrganizationBillingChangePlanBody },
  TContext
> => {
  const mutationOptions = getPostOrganizationBillingChangePlanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
